<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.4668 6.48047V8.67797H10.1543C10.5668 7.97297 11.0243 7.20047 11.4668 6.48047Z"
            fill="#FF9E48"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5 1.5H13.5C14.745 1.5 15.75 2.4975 15.75 3.7275V11.91C15.75 13.14 14.745 14.1375 13.5 14.1375H12.9375C12.345 14.1375 11.7675 14.37 11.3475 14.79L10.065 16.0575C9.48 16.635 8.5275 16.635 7.9425 16.0575L6.66 14.79C6.24 14.37 5.67 14.1375 5.07 14.1375H4.5C3.255 14.1375 2.25 13.14 2.25 11.91V3.7275C2.25 2.4975 3.255 1.5 4.5 1.5ZM8.3475 10.32C8.3475 10.0125 8.0925 9.7575 7.785 9.7575V9.765H5.955C6.1425 9.4275 6.5175 9.1725 6.915 8.9025L6.91945 8.89947C7.55619 8.46499 8.3475 7.92504 8.3475 6.87C8.3475 5.8575 7.53 5.04 6.5175 5.04C5.505 5.04 4.6875 5.865 4.6875 6.87C4.6875 7.1775 4.9425 7.4325 5.25 7.4325C5.5575 7.4325 5.8125 7.1775 5.8125 6.87C5.8125 6.48 6.12 6.1575 6.51 6.1575C6.9 6.1575 7.215 6.4725 7.215 6.8625C7.215 7.2975 6.8775 7.5525 6.2775 7.9575L6.26051 7.96912C5.69474 8.35617 5.0599 8.79046 4.8 9.585C4.71 9.885 4.755 10.2 4.9425 10.455C5.1375 10.725 5.445 10.8825 5.775 10.8825H7.785C8.0925 10.8825 8.3475 10.6275 8.3475 10.32ZM12.5925 9.81H12.75C13.0575 9.81 13.3125 9.5625 13.3125 9.255C13.3125 8.9475 13.0575 8.6925 12.75 8.6925H12.585V6.0525C12.5925 5.6025 12.2925 5.2125 11.865 5.085C11.4375 4.965 10.98 5.1375 10.74 5.52C10.2 6.39 9.6075 7.3875 9.0975 8.265C8.91 8.58 8.91 8.9775 9.0975 9.3C9.285 9.615 9.6225 9.81 9.99 9.81H11.4675V10.3275C11.4675 10.635 11.7225 10.89 12.03 10.89C12.3375 10.89 12.5925 10.635 12.5925 10.3275V9.81Z"
            fill="#FF9E48"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
